import React from 'react'
import { Text } from 'react-native'
import { useTranslation } from 'react-i18next'
import { useInvoiceDetailsContext } from '../../../TabInvoice/InvoiceDetailsContext'
import { SuccessFailurePrompt } from '../../../../../ui/molecules/SuccessFailurePrompt'
import { PromptSuccessIcon } from '../../../../../assets/icons'
import { paths } from '../../../../links'

export const UploadedInvoicePaymentSuccessAlert = ({ navigation }) => {
  const { t } = useTranslation('global')
  const { inviteSuccessModal, setInviteSuccessModal } =
    useInvoiceDetailsContext()
  return (
    <SuccessFailurePrompt
      visible={inviteSuccessModal}
      onDismiss={() => navigation.goBack()}
      contentContainerStyle={{ marginHorizontal: 40 }}
      title={t('UploadedInvoicePaymentSuccess.title')}
      textContentBottomMargin={20}
      icon={<PromptSuccessIcon />}
      message={<Text>{t('UploadedInvoicePaymentSuccess.message')}</Text>}
      buttonData={{
        title: 'Ok, got it',
        onPress: () => {
          setInviteSuccessModal(false)
          navigation.navigate(paths.Console.InvoicesToPay.Listing)
        },
        style: { width: 150 },
      }}
    />
  )
}
